// IntersectionObserver — reveal-up animations
// Disable hiding in Shopify editor so content is always visible while editing
const inEditor = window.Shopify && window.Shopify.designMode;

if (!inEditor) {
  document.documentElement.classList.add('js-animations');
}

const revealObserver = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('active');
        revealObserver.unobserve(entry.target);
      }
    });
  },
  { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
);

function initReveal(root) {
  (root || document).querySelectorAll('.reveal-up').forEach((el) => revealObserver.observe(el));
}

initReveal();

// Re-observe when Shopify editor reloads a section (e.g. after changing an image)
document.addEventListener('shopify:section:load', (e) => initReveal(e.target));
document.addEventListener('shopify:section:reorder', () => initReveal());

// Nav — solid background on scroll
const nav = document.getElementById('nav');

if (nav) {
  window.addEventListener('scroll', () => {
    nav.classList.toggle('scrolled', window.scrollY > 80);
  }, { passive: true });
}

// Hamburger menu toggle
const hamburger = document.querySelector('.nav-hamburger');
const mobileMenu = document.getElementById('nav-mobile-menu');
if (hamburger && mobileMenu) {
  hamburger.addEventListener('click', () => {
    const isOpen = !mobileMenu.hidden;
    mobileMenu.hidden = isOpen;
    hamburger.setAttribute('aria-expanded', String(!isOpen));
    hamburger.querySelector('.material-symbols-outlined').textContent = isOpen ? 'menu' : 'close';
  });
  mobileMenu.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', () => {
      mobileMenu.hidden = true;
      hamburger.setAttribute('aria-expanded', 'false');
      hamburger.querySelector('.material-symbols-outlined').textContent = 'menu';
    });
  });
}